import React from 'react';
import ReactPaginate from 'react-paginate';

const SecondStep = props => (
  <div className='fdvEquip-slides-item simpleSlide active'>
    <h6 className='h5 mb-4'>
      <span className='bold'>N° Pedidos</span>
      <br />

        {props.pedidosEquiposAdicionales.map((pedido, id) => (

            pedido.status !== 0 ? (<span key={id} >{pedido + ' ' }</span>
            ) : null
          ))}

    </h6>



    <div className='row'>
      <div className='col-md-4'>
        <div className='form-group'>
          <label className='labelInfo'>Tipo de adicional</label>

          <div className='select'>
            <select name='tipoAdicionalSelect' onChange={props.onChangeValue} value={props.tipoAdicionalSelect} className='form-control'>
            <option></option>
              {props.tipoAdicional.map((tipo, id) => (
                <option value={tipo.id}>{tipo.nombre}</option>
              ))}
            </select>

            <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
          </div><span className='error'>mensaje de error</span>
        </div>
      </div>

    </div>
    <div className='tableSearch'>

        {props.nomPerso!==''?(
        <ol className='breadcrumb'>
          <li className='breadcrumb-item'>
            <button className='btn-link breadcrumb-item-content' onClick={() => props.onClickRetornar()} >
              <p className='breadcrumb-item-title'>Clientes</p>
            </button>
          </li>
          <li className='breadcrumb-item'>
            <div className='breadcrumb-item-content'>
              <p className='breadcrumb-item-head'>Proforma de:</p>
              <p className='breadcrumb-item-title'>{props.nomPerso}:</p>
            </div>
          </li>
        </ol>

      ):null}


      <h4 className='mt-4 mb-2 labelInfo'>Bucar proforma por cliente o número:</h4>
      <div className='pillSelct'>
        <ul className='pillSelct-pills' />
      </div>


      <div className='row'>
        <div className='col-md-6 mb-3 mt-2'>
          <div className='fSearch'>
            <div className='fSearch-filter form-control'>
              <select
                value={props.searchOption}
                onChange={props.typeSearch}
                className='searchOption'
                name='searchOption'
              >
                <option value='equipo' >Equipo</option>
                <option value='codequipo'> Cód. Equipo </option>
                <option value='proveedor'>Proveedor</option>
                <option value='codproveedor'>Cód. Proveedor</option>
              </select>
            </div>
            <input
              type='text'
              className='fSearch-search form-control'
              placeholder='Ingrese el dato seleccionado'
              name='clientInput'
              value={props.clientInput}
              onChange={props.onChangeInput}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  props.searchProveedorEquiposAdicionales();
                }
              }}
            />
            <button className='btn btn-dark fSearch-go' onClick={() => props.searchProveedorEquiposAdicionales()}><i className='ion-search icon-md' /></button>
          </div>

        </div>
      </div>

    <div style={{display:props.divProveedores}}>
      <div className='hidden-xs'>
        <div className='tableWrapper'>
          <table className='table table-hover table-link'>
            <thead className='table-head'>
              <tr >
                <th>Cód. Proveedor</th>
                <th>Proveedor</th>
              </tr>
            </thead>
            <tbody>
              {props.proveedorEquposAdicionales.proveedor.map((proveedor, id) => (
                <tr key={id} onClick={() => props.fnSeleccionProveedor(proveedor.codProv,proveedor.nomPerso)}>
                  <td>{proveedor.codProv}</td>
                  <td>{proveedor.nomPerso}</td>
                </tr>
            ))}
            </tbody>
          </table>
        </div>
        <div className={props.proveedorEquposAdicionales.cantidad > 1 ? 'paginationWrapper' : 'hidden'}>
          <div className='row'>

            <div className='col-sm-6 pull-right'>
              <ReactPaginate
                pageCount={props.proveedorEquposAdicionales.cantidadPaginas}
                onPageChange={props.handlePageClickEquiposEspeciales}
                previousLabel='<<'
                nextLabel='>>'
                containerClassName='pagination pull-right'
                pageClassName='pagination-item'
                activeClassName='pagination-item--active'
                pageLinkClassName='btn-clean pagination-item-btn'
                breakClassName='break pagination-item'
              />
            </div>
          </div>
        </div>
      </div>
  </div>
  <div style={{display:props.divEquiposAdicionales}}>

      <div className='card card-lg card-plain'>
        <div className='pillSelct-pills'>
        {props.equiposProveedorSeleccionado.sort(function (a, b) {
                    if (a.codEquipo > b.codEquipo) {
                      return 1;
                    }
                    if (a.codEquipo < b.codEquipo) {
                      return -1;
                    }
                    return 0;
      }).map((equipos, id) => (
           equipos.cantidad >0 ? (<label key={id} className='pill pill-cyan pillSelct-pills-item'>{equipos.cantidad + ' ' +equipos.descEquipo}
             <button className='pillSelct-delete'><i className='icon ion-close pill-close' onClick = {()=> props.eliminateAdditionalEquipment(equipos.codEquipo)} /></button>
           </label>
           ) : null
         ))}
        </div>
      </div>


      <div className='hidden-xs' >
        <div className='tableWrapper'>
          <table className='table table-hover'>
            <thead className='table-head'>
              <tr>
                <th>SKU</th>
                <th>Equipo Localss</th>
                <th>Cantidad</th>
                <th>Precio</th>
              </tr>
            </thead>
            <tbody>
          {
          props.equiposProveedor!==undefined?props.equiposProveedor.sort(function (a, b) {
                    if (a.codEquipo > b.codEquipo) {
                      return 1;
                    }
                    if (a.codEquipo < b.codEquipo) {
                      return -1;
                    }
                    return 0;
                }).map((equipos,id) =>(

                  <tr key={id}>
                    <td>{equipos.codEquipo}</td>
                    <td>{equipos.descEquipo}</td>
                    <td>
                      <div className='stepper'>
                        <div className='stepper-control'>
                          <i className='ion-android-remove stepper-control-minus'
                           onClick = {()=> props.adicionRestasEquiposAdicionales(equipos.codEquipo,0,2)}
                          ng-init='countsearchStepper0 = 0' />
                          <input id={'inputEquipo' +id} className='stepper-control-number' value={props.equiposProveedorSeleccionado.filter(equipoSeleccionado => equipoSeleccionado.codEquipo===equipos.codEquipo)[0]===undefined?'0':props.equiposProveedorSeleccionado.filter(equipoSeleccionado => equipoSeleccionado.codEquipo===equipos.codEquipo)[0].cantidad} readOnly name='searchStepper0' /><i className='ion-android-add stepper-control-plus'
                           onClick = {()=> props.adicionRestasEquiposAdicionales(equipos.codEquipo,1,2)}/>
                        </div>
                        <label className='error' generated='true' htmlFor='searchStepper0' />
                      </div>
                    </td>
                    <td id={'td' +id} >{equipos.precio}</td>
                  </tr>

                )):null
              }

              {props.numeroPaginas === 0 ?(
                <tr >
                <td colspan ="4"><p style={{'text-align':'center'}}>No existe registros para la busqueda.</p></td>
                </tr>
              ):null}

            </tbody>
          </table>
        </div>
      </div>

      {  props.numeroPaginas > 0?(
        <div className='paginationWrapper'>
        <div className='row'>
          <div className='col-sm-6 pull-right'>
            <ReactPaginate
              pageCount={props.numeroPaginas}
              onPageChange={props.handlePageClick}
              previousLabel='<<'
              nextLabel='>>'
              containerClassName='pagination pull-right'
              pageClassName='pagination-item'
              activeClassName='pagination-item--active'
              pageLinkClassName='btn-clean pagination-item-btn'
              breakClassName='break pagination-item'
            />
          </div>
        </div>
        </div>

      ):(null)

      }


    </div>

      </div>

    <div className='modal-actions'>
      <button className='btn btn-default' onClick={props.previousStep}>Anterior</button>
      <button className='btn btn-primary pull-right' onClick={props.nextStep}>Siguiente</button>
    </div>

  </div>

);

export default SecondStep;



// WEBPACK FOOTER //
// ./src/pages/modals/AgregarEquiposAdicionales/SecondStep.js